const getDefaultState = () => {
	return {
		error: null,
	};
};

const state = getDefaultState();

const actions = {
	reset({commit}) {
		commit("RESET");
	},
};

const mutations = {
	RESET(state) {
		Object.assign(state, getDefaultState());
	},
	ERROR(state, error) {
		state.error = error.response.status;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
